// extracted by mini-css-extract-plugin
module.exports = {"pixImage":"PixImage_pixImage__1Dqhg","imageIcon":"PixImage_imageIcon__1pLqU"};